import { Field, Form, Formik } from "formik";
import "moment-timezone";
import React, { Component } from "react";
import { Button, ControlLabel } from 'react-bootstrap';
import Alert from 'react-s-alert';
import * as Yup from "yup";
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from '../utils/DealsService';
import UsersService from '../utils/UsersService';





class ReviewSaleForm extends Component {
  state = {}

  constructor(props) {
    super(props);
    UsersService.allUsers().then((data) => {
      this.setState({ users: data })
    })
  }

  render() {
    const { onCancelSubmit } = this.props
    const validationSchema = Yup.object().shape({
      notes_review: Yup.string().max(2000, "maximum 2000 characters"),
      review_outcome: Yup.string().required("Outcome is required"),
      review_outcome_reason: Yup.string()
        .when('review_outcome', {
          is: (val) => val === 'declined',
          then: Yup.string().required('please provide a reason'),
          otherwise: Yup.string().notRequired()
        })
    });

    return (
      <Formik
        initialValues={{
          review_outcome: '',
          review_outcome_reason: '',
          notes_review: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const { onSubmit } = this.props
          const { deal } = this.props
          const action = 'review_done_' + values.review_outcome
          DealsService.takeAction(action, deal.id, values)
            .then(data => {
              Alert.success('Completed review')
              onSubmit(data)
              setSubmitting(false);
            });
        }}
        render={({
          errors,
          touched,
          isValid,
          isSubmitting,
          values
        }) => (
            <Form>
              <div className='row'>
                <div className='col-sm-6'>
                  <FormikFormControl fieldName='review_outcome' errors={errors} touched={touched}>
                    <ControlLabel>Review outcome</ControlLabel>
                    <Field className="form-control input-sm" name="review_outcome" component="select">
                      <option value=''>-- select --</option>
                      <option value='approved'>Approved</option>
                      <option value='declined'>Declined</option>
                    </Field>
                  </FormikFormControl>
                </div>
                <div className='col-sm-6'>
                  {values.review_outcome === 'declined'
                  && <FormikFormControl fieldName='review_outcome_reason' errors={errors} touched={touched}>
                      <ControlLabel>Reason</ControlLabel>
                      <Field className="form-control input-sm" name="review_outcome_reason" component="select">
                        <option value=''>-- select --</option>
                        <option value='misrepresented_product'>Sales did not explain product properly</option>
                        <option value='too_expensive'>Too expensive, couldn't pay / afford</option>
                        <option value='not_interested'>Not interested</option>
                        <option value='other'>Other (please explain clearly in notes)</option>
                      </Field>
                    </FormikFormControl>
                  }
                </div>
              </div>
              <FormikTextAreaControl fieldLabel='Review Notes' fieldName='notes_review' errors={errors} touched={touched} />

              <div>
                {onCancelSubmit && <Button onClick={onCancelSubmit} bsSize='small'>Whoops, cancel this</Button>}
                <div className='pull-right'>
                  <Button disabled={!isValid || isSubmitting} type="submit" bsStyle='success' bsSize='small' style={{marginLeft: 10}}>Review Done</Button>
                </div>
              </div>
            </Form>
          )} />

    )
  }
}

export default ReviewSaleForm